import React from 'react';
import Name from '../../components/ui/Name';
import profile from './profile';

// Revert discovery to get "what" field translation
import discovery from './discovery';

export default {
	fields: {
		...profile.fields,
		stageName: {
			label: `Nom`,
			placeholder: ``,
			helper: ``
		},
		what: {
			label: `Choisissez une option`,
			...discovery.check.other.select.values,
		}
	},
	tab: profile.tab,
	tabs: profile.tabs,
	modales: {
		deleteProfile: {
			title: `Supprimer`,
			body: props => (<div>Êtes-vous sûr de vouloir supprimer <span className="modale-profile-name"><Name {...props } /></span> ?<br />Attention cette action est irréversible et ne pourra être annulée.</div>),
			yes: `Supprimer`,
			no: `Annuler`
		},
		addProfile: {
			title: `Ajouter`,
			cancel: `Annuler`,
			confirm: `Créer`,
			matchingProfiles: `Les trucs suivants peuvent correspondre au truc que vous souhaitez créer. Si c'est le cas, merci d'éditer la fiche du truc correspondant et ne pas créer un nouveau`,
			cgv: `Je certifie que le truc que je veux créer n'existe pas déjà.`,
			success: `truc créée avec succès ! Vous pouvez maintenant éditer sa fiche !`,
			search: {
				noResult: ``,
			}
		},
		confirmLightMerge: {
			title: `Lier un compte social à un truc`,
			body: profile => (<div>Êtes-vous sûr(e) de vouloir lier ce compte social à <span className="modale-profile-name"><Name {...profile } /></span> ?</div>),
			yes: `Oui, lier`,
			no: `Annuler`
		},
		merge: {
			title: `Fusionner avec...`,
			cancel: `Annuler`,
			matchingProfiles: `Sélectionnez le truc avec lequel vous souhaitez fusionner.`,
			merge: `Fusionner`,
			search: {
				noResult: ``,
			}
		},
		confirmMerge: {
			title: `Sélectionner les champs à conserver`,
			confirm: `Fusionner`,
			cancel: `Annuler`,
			emptyProfile: `Champs libres`
		},
		mergeError: {
			title: 'Fusion impossible',
			body: `Désolé, ces 2 trucs correspondent à des célébrités distinctes, ou des membres community, et ne peuvent donc pas être fusionnées.`,
			ok: `Ok`,
		},
	}
}
